module.exports = __webpack_public_path__ + "static/media/instagram-footer.bb9975d1.svg";